import { Theme } from '@mui/material/styles';

// ==============================|| OVERRIDES - CARD ||============================== //

export default function Card(theme: Theme) {
  return {
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: 'none !important',
          backgroundColor: 'transparent !important',
          boxShadow: 'none !important'
        }
      }
    }
  };
}

